import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ContactenIcon } from "../../atoms/icons/ContactenIcon";
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<number>;
export const Contacten = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');

    const label = props.label || tDatatypes('contactenLabel') || "Contacten";
    return (<Caption {...props} caption={label} icon={<ContactenIcon />}>
        {props.value}
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));